import { makeReducerPermission } from "@atoms/atom-types";

export const triggerImportOrdersPermission = makeReducerPermission({
  reducerName: "triggerImportOrders",
});

export const afsImportApiPermission = makeReducerPermission({
  reducerName: "afsImportApi",
});
